import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0f333b4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d0f333b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f333b4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Filters: require('/var/www/k9-frontend/k9-front-20261006142511/components/filters/Filters.vue').default})
